import { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';
import { useAuth } from '@/hooks/useAuth';
import { AppLayoutSkeleton } from '@/components/templates/skeletons';

interface RoleGuardProps {
  requiredRole: 'admin' | 'courseAdmin' | 'superAdmin';
  children: React.ReactNode;
}

const ROLE_FLAG_MAP = {
  admin: 'isAdmin',
  courseAdmin: 'isCourseAdmin',
  superAdmin: 'isSuperAdmin',
} as const;

const REDIRECT_PATH = '/dashboard';

export const RoleGuard = memo(function RoleGuard({ requiredRole, children }: RoleGuardProps) {
  const { user, loading: authLoading } = useAuth();
  const roleData = useUserRole();
  const flagKey = ROLE_FLAG_MAP[requiredRole];

  if (authLoading || !user || roleData.isLoading) {
    return <AppLayoutSkeleton />;
  }

  if (!roleData[flagKey]) {
    return <Navigate to={REDIRECT_PATH} replace />;
  }

  return <>{children}</>;
});
